/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "HSN_INWARD/LOADER_STATUS";
export const PROFILE_INFO = "HSN_INWARD/PROFILE_INFO";
export const SET_VARIANCE_DATA = "HSN_INWARD/SET_VARIANCE_DATA";
export const SET_HSN_LIST = "HSN_INWARD/SET_HSN_LIST";
export const SET_GST_LIST = "HSN_INWARD/SET_GST_LIST";
export const SET_RET_PERIOD = "HSN_INWARD/SET_RET_PERIOD";
export const SET_VAULE_BY_TOP_HSN = "HSN_INWARD/SET_VAULE_BY_TOP_HSN";

export const SET_HSN_VAULE_QTR = "HSN_INWARD/SET_HSN_VAULE_QTR";

export const SET_SPLY_VALUE_HSN = "HSN_INWARD/SET_SPLY_VALUE_HSN";
export const SET_SPLY_VALUE_RATIO = "HSN_INWARD/SET_SPLY_VALUE_RATIO";

export const SET_CLEAR_GRAPH = "HSN_INWARD/SET_CLEAR_GRAPH";
